<template>
    <div class="row mb-5">
        <div class="col-md-6 col-sm-11 mx-auto">
            <button :disabled="!readyForAnalysis || analysisInProgress" class="btn btn-primary" @click="runAnalysis">
                Run analysis
            </button>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import EventBus from '../eventBus'

    export default {
        props: {
            readyForAnalysis: Boolean
        },
        data: function () {
            return {
                analysisInProgress: false
            }
        },
        computed: {
            ...mapGetters([
                'urls',
                'projectStates',
                'project'
            ]),
            extraURLParametersForAPI: function () {
                let params = '';
                if (this.project.recipe.uses_column)
                    params += '&predictionColumnIndex=' + this.project.prediction_column_index;
                if (this.project.max_results_num)
                    params += '&maxCorrelations=' + this.project.max_results_num;
                return params;
            }
        },
        mounted() {
            if(this.readyForAnalysis)
                this.runAnalysis();
        },
        methods: {
            ...mapActions([
                'openModal',
                'setLoading',
                'setModalAllowClose',
                'setMessage',
                'requestRecipeFromAPI',
                'handleError',
                'setProject'
            ]),
            runAnalysis() {
                this.analysisInProgress = true;
                let instance = this;
                instance.openModal();
                instance.setLoading(true);
                instance.setModalAllowClose(true);
                instance.setMessage('Your recipe is being cooked!<br />Please wait, this process may take from 5 minutes to 1 hour.<br><br>' +
                    'Feel free to close this window. Once your recipe is ready, we will notify you with an email!');
                let url = instance.urls.apiUrl + instance.project.recipe.api_path + '/request?projectId=' +
                    instance.project.code;
                url += this.extraURLParametersForAPI;
                axios.post(
                    url,
                    {}, {headers: {'Bearer': process.env.MIX_API_AUTH_TOKEN}})
                    .then(function (response) {
                        return axios.post(instance.urls.postProjectUrl, instance.project, {headers: {'Accept': 'application/json'}});
                    })
                    .then(function (response) {
                        return axios.get(instance.urls.requestRecipeUrl + '?projectCode=' + instance.project.code, {headers: {'Accept': 'application/json'}});
                    })
                    .then(function (response) {
                        instance.setLoading(true);
                        instance.openModal();
                        EventBus.$emit('ANALYSIS_READY', response);
                    })
                    .catch(function (error) {
                        instance.handleError(error);
                        instance.analysisInProgress = false;
                    });
            }
        }
    }
</script>

<style lang="scss">

</style>
